var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1875 11.625H17.4375V3.875H5.8125V27.125H25.1875V11.625ZM24.3854 9.6875L19.375 4.67712V9.6875H24.3854ZM4.84375 1.9375H19.375L27.125 9.6875V28.0938C27.125 28.3507 27.0229 28.5971 26.8413 28.7788C26.6596 28.9604 26.4132 29.0625 26.1562 29.0625H4.84375C4.58682 29.0625 4.34042 28.9604 4.15874 28.7788C3.97706 28.5971 3.875 28.3507 3.875 28.0938V2.90625C3.875 2.64932 3.97706 2.40292 4.15874 2.22124C4.34042 2.03956 4.58682 1.9375 4.84375 1.9375ZM9.6875 15.5H21.3125V17.4375H9.6875V15.5ZM9.6875 9.6875H14.5312V11.625H9.6875V9.6875ZM9.6875 21.3125H21.3125V23.25H9.6875V21.3125Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.ecaf9d9853f978c13690ec903ab4c2c5.svg";
export { ForwardRef as ReactComponent };